// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"406":"27f7b36f","453":"20359781","560":"0752a811"}[chunkId] + ".chunk.js";
};